import React from "react";

const highlights = [
  { icon: "ri-calculator-line", label: "Instant math help" },
  { icon: "ri-file-text-line", label: "Smart note making" },
  { icon: "ri-quill-pen-line", label: "Grammar polish" },
];

const AuthLayout = ({
  children,
  title,
  subtitle,
  panelTitle,
  panelCopy,
}) => {
  return (
    <main className="relative min-h-[calc(100vh-72px)] overflow-hidden bg-brand-surface">
      <div
        className="pointer-events-none absolute -left-24 top-16 h-72 w-72 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.22),transparent_70%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-16 bottom-10 h-80 w-80 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(10,43,30,0.1),transparent_72%)]"
        aria-hidden="true"
      />

      <div className="relative mx-auto grid min-h-[calc(100vh-72px)] w-full max-w-6xl lg:grid-cols-2">
        <aside className="relative flex flex-col justify-between overflow-hidden bg-[linear-gradient(160deg,#072419_0%,#0a2b1e_48%,#0e4a3a_100%)] px-6 py-7 text-white sm:px-8 sm:py-10 lg:px-12 lg:py-14">
          <div
            className="pointer-events-none absolute inset-0 opacity-40"
            aria-hidden="true"
            style={{
              backgroundImage:
                "radial-gradient(circle at 20% 20%, rgba(23,191,158,0.35), transparent 42%), radial-gradient(circle at 80% 70%, rgba(216,245,238,0.12), transparent 45%)",
            }}
          />
          <div
            className="pointer-events-none absolute -right-10 top-24 h-48 w-48 animate-float rounded-full border border-white/10 max-lg:hidden"
            aria-hidden="true"
          />

          <div className="relative z-[1] animate-fade-up">
            <h1 className="mb-2 max-w-[14ch] font-display text-[clamp(1.7rem,4vw,2.75rem)] font-extrabold leading-none tracking-tight text-white lg:mb-3">
              {panelTitle}
            </h1>
            <p className="m-0 max-w-[34ch] text-[0.98rem] leading-relaxed text-white/80 lg:text-[1.02rem]">
              {panelCopy}
            </p>
          </div>

          <ul className="relative z-[1] mt-8 flex flex-wrap gap-2.5 max-lg:hidden">
            {highlights.map((item, index) => (
              <li
                key={item.label}
                className={`inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3.5 py-2 font-display text-sm text-white/90 backdrop-blur-sm ${
                  index === 0
                    ? "animate-fade-up-1"
                    : index === 1
                      ? "animate-fade-up-2"
                      : "animate-fade-up-3"
                }`}
              >
                <i className={`${item.icon} text-brand-teal`} />
                {item.label}
              </li>
            ))}
          </ul>
        </aside>

        <section className="relative flex items-center justify-center px-5 py-10 sm:px-8 lg:px-12 lg:py-14">
          <div className="w-full max-w-[420px] animate-fade-up">
            <div className="mb-8">
              <h2 className="mb-2 font-display text-[1.85rem] font-bold tracking-tight text-brand-forest">
                {title}
              </h2>
              <p className="m-0 text-[1rem] text-brand-muted">{subtitle}</p>
            </div>
            {children}
          </div>
        </section>
      </div>
    </main>
  );
};

export default AuthLayout;
